import * as React from 'react';

import {CheckmarkButton} from '../button/checkmark-button/checkmark-button';
import {CloseButton} from '../button/close-button/close-button';
import {EditThickerIcon} from '../icon/svg/edit-thicker-icon';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from '../icon/svg/upgrade-arrow-icon';

import {TextField} from './textfield';

type Props = {
    value: string;
    onTextfieldChange: (newValue: string) => void;
    placeholder?: string;
    isDisabled?: boolean;
    autoFocus?: boolean;
    hasError?: boolean;
    onSave: () => void;
    onCancel: () => void;
    onSelectEdit: () => void;
    isEditing: boolean;
    noBorder?: boolean;
    showUpgradeButton?: boolean;
    hideEditButton?: boolean;
    onClickUpgradeButton?: () => void;
};

/* Responsible for rendering a textfield with an edit button and a
 save (check) and cancel (X) button when in the editing state. 
 The functions for saving and canceling are passed in as props.
 The editing state is also handled by the parent component. The reason
 being that we want to set the editing state to false when the text is saved,
 but not if there is an error, and the saving and error handling is also done
 by the parent component. */
export function TextfieldWithSaveAndCancel(props: Props) {
    const {value = ''} = props;

    const buttonContainerRef = React.createRef<HTMLElement>();
    const textFieldRef = React.useRef<HTMLInputElement | null | undefined>();

    React.useLayoutEffect(() => {
        if (
            buttonContainerRef &&
            buttonContainerRef.current &&
            textFieldRef &&
            textFieldRef.current
        ) {
            const textField: HTMLInputElement = textFieldRef.current;

            const width = buttonContainerRef.current.getBoundingClientRect().width;

            textField.style.paddingRight = `${width + 4}px`;
        }
    }, [buttonContainerRef, textFieldRef]);

    return (
        <div className='full-width pos-relative'>
            <TextField
                // @ts-expect-error
                autoFocus={props.autoFocus}
                value={value}
                placeholder={props.placeholder}
                onChange={props.onTextfieldChange}
                disabled={props.isDisabled}
                hasError={props.hasError}
                textFieldRef={textFieldRef}
                noBorder={props.noBorder}
                readOnly={!props.isEditing}
            />
            <div
                className='pos-absolute flex align-center justify-center gap-4 top-0 bottom-0 right-0'
                // @ts-expect-error
                ref={buttonContainerRef}
            >
                {props.isEditing ? (
                    <>
                        <CheckmarkButton
                            onClick={() => {
                                props.onSave();
                            }}
                        />
                        <CloseButton
                            onClick={() => {
                                props.onCancel();
                            }}
                        />
                    </>
                ) : (
                    !props.hideEditButton && (
                        <button type='button' onClick={props.onSelectEdit}>
                            <EditThickerIcon size={18} />
                        </button>
                    )
                )}
                {props.showUpgradeButton && (
                    <button type='button' onClick={props.onClickUpgradeButton}>
                        <UpgradeArrowIcon size={18} />
                    </button>
                )}
            </div>
        </div>
    );
}
